import React from 'react';
import { EmptyLayout } from 'components/Layout';
import { Row,Spinner } from 'reactstrap';
import {clearStorage} from 'hooks/storage';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { LoginAction,UIAction } from 'redux/actions';

const LogoutPage = (props) => {

    const navigate = useNavigate();
    React.useEffect(()=>{
        clearStorage();
        props.clearLoginState();
    })

    React.useEffect(() => {
       if (!props.loginSuccess) {
            props.showMessages({status:'success',message:'You have logout successfully'});
            navigate('/login');
       }
      }, [props.loginSuccess])

    return (
        <EmptyLayout>
            <Row
                style={{
                    height: '100vh',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}>
                <div className="cr-page-spinner">
                    <div>Logging Out</div>
                    <Spinner color={'primary'} />
                </div>
            </Row>
        </EmptyLayout>
    );
}

const mapStateToProps = (state) => ({
    loginSuccess: (state.loginReducer && state.loginReducer.loginData && state.loginReducer.loginData.user && state.loginReducer.loginData.user.token) ? state.loginReducer.loginData.user.token : null
  });
const mapDispatchToProps = (dispatch) => ({
  clearLoginState: () => dispatch(LoginAction.loginSuccess(null)),
  showMessages: (data) => dispatch(UIAction.showMessages(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LogoutPage);
